import { removeData, storeData } from "../../helper/arrayFormatter";
import { API_LOGOUT } from "../../api/api";
import { axiosPost } from "../../services/http.services";
import { logoutUser, setUser } from "../slices/authSlice";

const parseJwtPayload = (token) => {
	if (!token || typeof token !== "string" || token.split(".").length < 2) {
		return null;
	}

	try {
		const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
		const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
		return JSON.parse(atob(padded));
	} catch (error) {
		return null;
	}
};

export const loginUser = async (userData, dispatch) => {
	try {
		const jwtPayload = parseJwtPayload(userData?.token);
		const normalizedUser = {
			...userData,
			role: jwtPayload?.role || userData?.role,
		};

		dispatch(setUser(normalizedUser));
		storeData("user", JSON.stringify(normalizedUser));
		storeData("token", normalizedUser?.token);
		return true;
	} catch (error) {
		console.log(error);
		return false;
	}
};

export const logoutUserAction = (dispatch) => {
	axiosPost(API_LOGOUT, {}).catch(() => {
		// Client logout still proceeds even if server logout fails.
	});
	removeData("user");
	dispatch(logoutUser());
};
